import { createContext, ReactElement, ReactNode, useContext } from 'react'

import { ReportsPdfDocumentProps } from '../../../hooks/useReportPdfExport'

const ReportsPdfDocumentContext = createContext<ReportsPdfDocumentProps | undefined>(undefined)

interface ReportsPdfDocumentContextProviderProps {
  value: ReportsPdfDocumentProps
  children?: ReactNode
}

export const ReportsPdfDocumentContextProvider = ({
  value,
  children,
}: ReportsPdfDocumentContextProviderProps): ReactElement => {
  return <ReportsPdfDocumentContext.Provider value={value}>{children}</ReportsPdfDocumentContext.Provider>
}

export const useReportsPdfDocument = () => {
  const context = useContext(ReportsPdfDocumentContext)

  if (!context) {
    throw new Error('ReportsPdfDocumentContextProvider is missing in the module!')
  }

  return context
}
